import { useEffect, useState } from "react";
import ReactDOM from "react-dom";

/**
 * Portal component that renders content into the NavBar's description area.
 * When content is rendered, it replaces the static route-handle description via CSS.
 */
export function NavbarDescriptionPortal({
  children,
}: {
  children: React.ReactNode;
}) {
  const [container, setContainer] = useState<HTMLElement | null>(null);

  useEffect(() => {
    setContainer(document.getElementById("navbar-description-container"));
  }, []);

  if (!container) return null;
  return ReactDOM.createPortal(children, container);
}
